import React, {useEffect, useState, useRef} from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import SearchSection from '../Reusables/SearchSection';
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList, parseTableHeaders, parseDataList } from '../../store/Actions';
import { useNavigate, useLocation } from "react-router-dom";
import '../../scss/entities.scss';
import TableView from '../Reusables/TableView';
import Spinner from '../Reusables/Spinner';
import getResponseEntity from '../actions/Entity.js';
import PageChange from '../Reusables/Pagination';
import DeleteItem from '../popups/DeleteItem';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import Upload from '../popups/Upload';
import Entries from '../Reusables/Entries';

import downArrow from '../../images/common/bluedownarrow.png';
import upArrow from '../../images/common/blueuparrow.png';

function ClickOutside(ref, setFilter) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setFilter(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function Entities() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const filename = 'Properties';

    const filterwrapperRef = useRef(null);
    const [isFilter, setFilter] = useState(false);
    ClickOutside(filterwrapperRef, setFilter);

    const[isLoading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(null);
    const [filterList, setFilterList] = useState([]);
    const [isDropdownClicked, setDropdownClick] = useState(false);
    const [filterParam, setFilterParam] = useState("");
    const [show, setShow] = useState(false);
    const [deleteEntityId, setDeleteEntityId] = useState(null);
    const [isDeleted, setDeleted] = useState(false);
    const [entityList, setEntityList] = useState([]);
    const [downloadArray, setDownloadArray] = useState([]);
    const [countList, setCountList] = useState([]);
    const [file, setFile] = useState(null);
    const [showImportPopup, setShowImportPopup] = useState(false);
    const [loadend, setLoadEnd] = useState(false);
    const [uploaderror, setUploaderror] = useState('');
    const [created, setCreate] = useState(false);
    const [uploadstate, setUpload] = useState(null);
    const [limit, setLimit] = useState(30);
    const [sortValues, setSortValues] = useState({
        sortBy: null,
        sortType: null
    })
    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Properties", "url": "properties/list" }
    ];
    const searchValues = {
        isFilter: true,
        isCreate: true,
        placeholder: "Search Property",
    }
    const tableHeaders = [
        { "name": "", "sort": false, "width": "50px" },
        { "name": "Property", "sort": true, "width": "250px" },
        { "name": "Property Code", "sort": true, "width": "200px" },
        { "name": "Brand", "sort": true, "width": "160px" },
        // { "name": "Email Id", "sort": false, "width": "180px" },
        // { "name": "Phone", "sort": false, "width": "140px" },
        { "name": "Address", "sort": false, "width": "180px" },
        { "name": "Actions", "sort": false, "width": "70px" }
    ];
    const headers = [
        { label: "Name", key: "name" },
        { label: "Property Code", key: "propertyCode" },
        { label: "Brand", key: "brandName" },
        // { label: "Email Id", key: "email" },
        // { label: "Phone", key: "phoneNumber" },
        { label: "Address", key: "address" }
    ]; 

    const handleImportPopupClose = () => setShowImportPopup(false);


    useEffect(() => {
        window.scroll(0, 0);
        dispatch(parseTableHeaders(tableHeaders));
        dispatch(parseBreadcrumbsList(breadcrumbsList));
        const path = new URLSearchParams(location.search);
        const pageParam = path.has('page') ? path.get('page') : 1;
        setPage(pageParam);

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getBrandList(accesstoken);
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [])

    useEffect(() => {
        window.scroll(0, 0);
        const path = new URLSearchParams(location.search);
        const search = path.has('search') ? path.get('search') : '';
        const sortBy = path.has('sort') ? path.get('sort') : '';
        const sortOrder = path.has('sort_order') ? path.get('sort_order') : '';
        const filter = path.has('brandId') ? path.get('brandId') : '';

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                 // Fot list
                callEntityListApi(`/api/entity/list?limit=${limit}&page=${page}${search ? `&search=${search}` : ''}${sortBy ? `&sortKey=${sortBy}` : ''}${sortOrder ? `&sortOrder=${sortOrder}` : ''}${filter ? `&brandId=${filter}` : ''}`, accesstoken);
                // For download
                callEntityListDownloadApi(`/api/entity/list?limit=${limit}&page=${page}&download=true${search ? `&search=${search}` : ''}${sortBy ? `&sortKey=${sortBy}` : ''}${sortOrder ? `&sortOrder=${sortOrder}` : ''}${filter ? `&brandId=${filter}` : ''}`, accesstoken);
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [page, isDeleted, uploadstate, limit])

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }

    const callEntityListApi = (endpoint, accesstoken) => {
        getResponseEntity.GetEntityList(endpoint, accesstoken, (data) => {
            if (data.status == 200) {
                console.log("[Entities] Fetched data", data.data.data);
                dispatch(parseDataList(data.data.data));
                setEntityList(data.data.data);
                setLoading(false);
                setTotalPages(data.data.totalPages);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });

        getResponseEntity.GetEntityList(`/api/entity/list?limit=${limit}&page=1`, accesstoken, (data) => {
            if (data.status == 200) {
                setCountList(data.data.data);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const callEntityListDownloadApi= (endpoint, accesstoken) => {
        getResponseEntity.GetEntityList(endpoint, accesstoken, (data) => {
            if (data.status == 200) {
                setDownloadArray(data.data.data);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const getBrandList = (accesstoken) => {
        getResponseEntity.GetBrandList('/api/brand/dropdown', accesstoken, (data) => {
            if(data.status == 200) {
                const response = data.data.data;
                setFilterList(data.data.data);
                const path = new URLSearchParams(location.search);
                const filter = path.has('brandId') ? path.get('brandId') : '';
                if(filter) {
                    console.log("Brands list", response);
                    response.length > 0 && response.map((brand) => {
                        if(Number(filter) == brand.idBrand) {
                            setFilterParam(brand.name);
                        }
                    })
                } else {
                    setFilterParam("All");
                }
            } else if(data.status == 401) {
                navigate("/login")
            }
        })
    }

    const HandlePageChange = (pageNumber) => {
        setPage(pageNumber);
        const path = new URLSearchParams(location.search);
        const search = path.has('search') ? path.get('search') : '';
        const sortBy = path.has('sort') ? path.get('sort') : '';
        const sortOrder = path.has('sort_order') ? path.get('sort_order') : '';
        const filter = path.has('brandId') ? path.get('brandId') : '';

        navigate(`/properties/list?page=${pageNumber}${sortBy ? `&sort=${sortBy}` : ''}${sortOrder ? `&sort_order=${sortOrder}` : ''}${search ? `&search=${search}` : ''}${filter ? `&brandId=${filter}` : ''}`);
    }

    const callSearchApi = (query) => {
        const path = new URLSearchParams(location.search);
        const sortBy = path.has('sort') ? path.get('sort') : '';
        const sortOrder = path.has('sort_order') ? path.get('sort_order') : '';

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                callEntityListApi(`/api/entity/list?limit=${limit}&page=1&search=${query}${sortBy ? `&sortKey=${sortBy}` : ''}${sortOrder ? `&sortOrder=${sortOrder}` : ''}`, accesstoken);
                navigate(`/properties/list/?page=1${sortBy ? `&sort=${sortBy}` : ''}${sortOrder ? `&sort_order=${sortOrder}` : ''}&search=${query}`);

                // For download
                callEntityListDownloadApi(`/api/entity/list?limit=${limit}&page=1&download=true&search=${query}${sortBy ? `&sortKey=${sortBy}` : ''}${sortOrder ? `&sortOrder=${sortOrder}` : ''}`, accesstoken);

                setFilterParam("All");
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const callSortApi = (dataset) => {
        const path = new URLSearchParams(location.search);
        const search = path.has('search') ? path.get('search') : '';
        setSortValues({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                navigate(`/properties/list?page=1&sort=${dataset.sortBy}&sort_order=${dataset.sortType}${search ? `&search=${search}` : ''}`);
                callEntityListApi(`/api/entity/list?limit=${limit}&page=1${search ? `&search=${search}` : ''}&sortKey=${dataset.sortBy == "property" ? "entity" : dataset.sortBy}&sortOrder=${dataset.sortType}`, accesstoken);

                // For download
                callEntityListDownloadApi(`/api/entity/list?limit=${limit}&page=1&download=true${search ? `&search=${search}` : ''}&sortKey=${dataset.sortBy == "property" ? "entity" : dataset.sortBy}&sortOrder=${dataset.sortType}`, accesstoken);

                setFilterParam("All");
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const toCreateNewEntity = () => {
        navigate('/properties/new');
    }

    const callFilterApi = (brandId, name) => {
        setFilterParam(name);
        setDropdownClick(!isDropdownClicked);

        const callApi = (accesstoken) => {
            callEntityListApi(`/api/entity/list?limit=${limit}&page=1${brandId ? `&brandId=${brandId}` : ''}`, accesstoken);
            navigate(`/properties/list/?page=1${brandId ? `&brandId=${brandId}` : ''}`);

            // For download
            callEntityListDownloadApi(`/api/entity/list?limit=${limit}&page=1&download=true${brandId ? `&brandId=${brandId}` : ''}`, accesstoken);
        }
        
        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const handleFilter = () => {
        setFilter(!isFilter);
    }

    const handleDropdown = () => {
        setDropdownClick(!isDropdownClicked);
    }

    const getDetails = (entityId, type) => {
        if(type == 'edit') {
            navigate(`/properties/${entityId}/edit`);
        } else if(type == 'overview') {
            navigate(`/properties/${entityId}/view`);
        }
    }

    const deleteEntity = () => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponseEntity.DeleteEntity(`/api/entity/delete?entityId=${deleteEntityId}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        console.log("Delete Entity", data.data.data);
                        setDeleted(!isDeleted);
                        handleClose();
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const openImportPopup = () => {
        setShowImportPopup(true);
        setLoadEnd(false);
        setUploaderror('');
        setCreate(!created);
    }

    const handleEntryDropdown = (value) => {
        setLimit(value)
        HandlePageChange(1);
    }
    

    return (
        <div className='entities-container'>
            <Header />

            <div className='row entities-sub-container'>
                <Sidebar />

                <div className='col-10 entities-body-container'>
                    <Breadcrumbs/>
                    <div className='sub-header'>
                        <Entries handleEntryDropdown={handleEntryDropdown} page="Entities"/>
                        <SearchSection values={searchValues} handleFilter={handleFilter} setDownloadtype="" downloadtype=""
                                downloadarray={downloadArray} headers={headers} filename={filename}
                            callSearchApi={(query) => callSearchApi(query)}  navigateTo={toCreateNewEntity} pageType="Entities"
                            openImportPopup={openImportPopup}/>  
                        {isFilter &&
                            <div className='brand-filter-dropdown'>
                                <div className='filter-details' ref={filterwrapperRef}>
                                    <div className='brand-details'>
                                        <div className='entity-heading heading'>Brands</div>
                                        <div className='dropdown'>
                                            <div className='dropdown-inner' onClick={handleDropdown}>
                                                <div className='dropdown-name'>{filterParam}</div>
                                                <img className='arrow'  src={isDropdownClicked ? upArrow : downArrow} alt=""></img>
                                            </div>
                                                {isDropdownClicked && countList != null && countList.length > 0 &&
                                                <div className='dropdown-content'>
                                                    <div className='dropdown-content-inner' onClick={() => callFilterApi('', 'All')}>All</div>
                                                    {                                                     
                                                        filterList.map((item, index) => {
                                                            return (
                                                                <>
                                                                    <div className='dropdown-content-inner' key={index} onClick={() => callFilterApi(item.idBrand.toString(), item.name)}>{item.name}</div>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                }
                                            </div>
                                            </div>
                                    </div>
                                <div className='filter-details-arrow'></div>
                            </div>
                        }           
                    </div>
                    <div className='table-body'>
                        {isLoading ?
                        (<Spinner/>) :
                        (<TableView getDetails={(entityId, type) => getDetails(entityId, type)}
                            handleShow={handleShow}
                            setDelete={(id) => setDeleteEntityId(id)} page="Entities" callSortApi={(dataset) => callSortApi(dataset)}
                            sortValues={sortValues}/>)}
                    </div>
                    <div className="pagination">
                        <PageChange  page={page} setPage="" totalpage={totalPages} HandleChange={(page) => HandlePageChange(page)}></PageChange>
                    </div>
                </div>
            </div>

            <Footer />

            {/* Showing delete popup */}
            <DeleteItem show={show} handleClose={handleClose} deleteApiCall={deleteEntity} enable={true}/>
            {/* Importing properties */}
            <Upload show={showImportPopup} handleClose={handleImportPopupClose} id={-1} setUpload={setUpload} uploadstate={uploadstate} setLoadEnd={setLoadEnd} loadend={loadend} setUploaderror={setUploaderror} uploaderror={uploaderror} created={created} pageType="Entities"/>
        </div>
    );
}

export default Entities;